export enum EventTypeEnum {
  RESERVATION = 'RESERVATION',
  DEPARTURE = 'DEPARTURE',
  RETURN = 'RETURN',
}
